module.exports = __webpack_public_path__ + "static/media/T14.528b66f2.jpg";